import React from 'react';
import { connect } from 'react-redux';
import { orgsCreateComment } from '../../../actions/OrgsComments';
import PostAvatar from '../../Post/PostAvatar'
import MentionTextarea from '../MentionTeaxtarea';
import {COMMENT_MAX_CHARACTER} from "../../../constants/actionTypes";
const mapStateToProps = state => {
    return {
        comments: state.OrgsComments.comments,
        currentUser: state.common.currentUser,
        comment: state.comments.comment,
        anonymousMode: state.user.anonymousMode
    }
}

const mapDispatchToProps = dispatch => ({
    onSubmit: dispatch(orgsCreateComment),
});

class CommentInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            text: '',
            replyMyPostsAndComments: this.props.post && this.props.post.replyMyPostsAndComments || 3,
            post_chars_left: 0,
            post_max_char:COMMENT_MAX_CHARACTER,
        };

        this.setBody = ev => {
            const char = ev.target.value.length;
            if(char <= COMMENT_MAX_CHARACTER){
                this.setState({text: ev.target.value,post_chars_left: char});
            }
        };

        this.createComment = ev => {
            ev.preventDefault();
            this.props.onSubmit(this.props.orgs.id, this.state.text,  parseInt(ev.target.value), parseInt(ev.target.value));
            this.setState({
                text: '',
                post_chars_left: 0,
                replyMyPostsAndComments: parseInt(ev.target.value)
            });

        };
    }

    render() {
        const {anonymousMode} = this.props
        let postUser = this.props.post  && this.props.post.author && this.props.post.author.userName
        let currentUser = this.props.currentUser && this.props.currentUser.userName
        return (
            <div className={`comment${anonymousMode ? "-dark" : ""}`}>
                <div className="card-block-new">
                    <div className="d-flex w-100">
                        <div className="commentbox" style={{ display: 'inline-block', width: '100%'}}>
                            <MentionTextarea
                                value={this.state.text}
                                changeBody={this.setBody}
                                placeholder="Write a comment..."
                                showMaxLengthCounter={true}
                                chars_left={this.state.post_chars_left}
                                max_chars={this.state.post_max_char}
                                maxlength={COMMENT_MAX_CHARACTER}
                            />
                            <span className="text-danger">{ postUser !== currentUser ?
                                this.props.comment &&
                                this.props.comment.response &&
                                this.props.comment.response.body &&
                                this.props.comment.response.body.responseStatus &&
                                this.props.comment.response.body.responseStatus.message || '' : null}</span>
                        </div>
                    </div>
                </div>
                <div className={`card-footer text-center ${anonymousMode ? "bgm" : ""}`}>
                    <ul className="commentset">
                        <li><button className={`btn btn-sm btn-group${anonymousMode ? "-dark" : ""}  replylink reply_group ${parseInt(this.state.replyMyPostsAndComments) === 2 && ''}`} value={2} title="Reply to friends..."  onClick={this.createComment}>Friends</button></li>
                        <li><button className={`btn btn-sm btn-public${anonymousMode ? "-dark" : ""}  replylink reply_public ${parseInt(this.state.replyMyPostsAndComments) === 3 && '' }`} value={3} title="Reply in public"  onClick={this.createComment}>Public</button></li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CommentInput);
